const contentPadding = (type) => {
    switch (type) {
    case 'chart':
        return '0px 0px 10px 0px';
    case 'chart-with-legend':
        return '0px 0px 10px 0px';
    case 'geo-lab':
    case 'table':
    case 'smarttable':
    case 'donut':
        return '0px';
    default:
        return '0px';
    }
};

export default contentPadding;



// WEBPACK FOOTER //
// ./src/helpers/contentPadding.js